import {fetchYaml} from "./yamlLoader";
import {BASE, joinUrl} from "./paths";
import type {GalleriesIndexYaml, PhotosIndexYaml, PhotoYaml, ResolvedPhoto} from "../types";

const INDEX_PATH = process.env.REACT_APP_GALLERIES_INDEX_PATH || "/_index.yaml";
const PHOTOS_DIR = process.env.REACT_APP_PHOTOS_PATH || "/photos";
const PHOTOS_INDEX_PATH = process.env.REACT_APP_PHOTOS_INDEX_PATH || "/_index.yaml";

export async function loadGalleriesIndex(): Promise<GalleriesIndexYaml> {
    const indexUrl = INDEX_PATH.startsWith("http") ? INDEX_PATH : joinUrl(BASE, INDEX_PATH);
    return await fetchYaml<GalleriesIndexYaml>(indexUrl);
}

export async function loadPhotosIndex(): Promise<PhotosIndexYaml> {
    const indexUrl = PHOTOS_INDEX_PATH.startsWith("http") ? PHOTOS_INDEX_PATH : joinUrl(BASE, PHOTOS_INDEX_PATH);
    return await fetchYaml<PhotosIndexYaml>(indexUrl);
}

export function resolvePhotoYaml(meta: PhotoYaml): ResolvedPhoto {
    return {
        ...meta,
        sizeUrls: [
            {
                w: 3840,
                h: 2160,
                url: joinUrl(BASE, PHOTOS_DIR, "3840x2160", meta.filename)
            },
            {
                w: 2048,
                h: 1152,
                url: joinUrl(BASE, PHOTOS_DIR, "2048x1152", meta.filename)
            },
            {
                w: 384,
                h: 384,
                url: joinUrl(BASE, PHOTOS_DIR, "384x384", meta.filename)
            },
        ]
    };
}